import EventProcessor from "../../../core/internal/event/EventProcessor"
import UserEvent from "../../../core/internal/event/UserEvent"
import { SessionManager } from "../../../core/internal/session/SessionManager"
import { UserManager } from "../../../core/internal/user/UserManager"
import { SessionEventTracker } from "../../session/track/index.browser"
import { Lifecycle } from "../../../core/internal/lifecycle/Lifecycle"
import { LifecycleChangeListener } from "../../../core/internal/lifecycle/LifecycleChangeListener"
import { UserEventDedupDeterminer } from "../dedup/UserEventDedupDeterminer"
import { UserEventDecorator } from "../../../core/internal/user/UserEventDecorator"

export default class BrowserEventProcessor implements EventProcessor, LifecycleChangeListener {
  private decorators: UserEventDecorator[] = []

  constructor(
    private readonly delegate: EventProcessor,
    private readonly eventDedupDeterminer: UserEventDedupDeterminer,
    private readonly sessionManager: SessionManager,
    private readonly userManager: UserManager
  ) {}

  addDecorator(decorator: UserEventDecorator): void {
    this.decorators.push(decorator)
  }

  process(event: UserEvent): void {
    if (!SessionEventTracker.isSessionEvent(event)) {
      this.sessionManager.startNewSessionIfNeeded(this.userManager.currentUser, event.timestamp)
    }

    if (this.eventDedupDeterminer.isDedupTarget(event)) {
      return
    }

    const decoratedEvent = this.decorators.reduce((acc, decorator) => decorator.decorate(acc), event)
    this.delegate.process(decoratedEvent)
  }

  flush(sync: boolean): void {
    this.delegate.flush(sync)
  }

  close(): void {
    this.delegate.close()
  }

  onLifecycleChanged(lifecycle: Lifecycle, _: number): void {
    switch (lifecycle) {
      case "hidden":
      case "pagehide":
        return this.flush(true)
      case "blur":
      case "focus":
      case "locationChange":
      case "visible":
      case "pageshow":
        return
    }
  }
}
